import { mdlPremiumMainCoversCompRenewal } from "./mdlPremiumMainCoversCompRenewal";
import { mdlDriverNCDDetailsCompRenewal } from "./mdlDriverNCDDetailsCompRenewal";

export class mdlCalculatePremiumCompRenewalReq{
    public PolicyNo: string; 
    public RepairType: number; 
    public DeductableType: string;
    public SumInsured: number;
    public PromoCode:string; 
    public PromoDiscPer: number;
    public PromoId: string;
    public PromoDiscountType: string;
    public PromoDiscFlatAmount: string;
    public CoverDetails: Array<mdlPremiumMainCoversCompRenewal> = new Array<mdlPremiumMainCoversCompRenewal>();
    public DriverNCDDetails: mdlDriverNCDDetailsCompRenewal = new mdlDriverNCDDetailsCompRenewal();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCalculatePremiumCompRenewalReq.ts